export default {
  routerBase: {
    'a1': '家人',
    'a2': '綁定帳號',
    'a3': '新添家人',
    'a4': '編輯家人',
    'a5': '新增記錄',
    'a6': '臟音',
    'a7': '步數',
    'a8': 'HRV',
    'a9': '呼吸暫停',
    'a10': '血壓',
    'a11': '血糖',
    'a12': '心率',
    'a13': '心電',
    'a14': '心臟負荷',
    'a15': '血氧',
    'a16': '動脈硬化指數',
    'a17': 'sos預警',
    'a18': '健康分析',
    'a19': 'BMI'
  }
}
